/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FRAuth, FRStep } from '@forgerock/javascript-sdk';

import { FormContainer } from 'react-hook-form-mui';
import { useForm } from 'react-hook-form';

import { Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';
import SuccessErrorModal from '../../modals/SuccessErrorModal';
import FormLayout from '../../layout/form';
import FormSection from '../../01-atoms/FormSection';
import Row from '../../01-atoms/Row';
import { BaseCallBackInterface } from '../common/basInterface';

export default function SelectMFAMethod({ step, setStep,messageType,setMessageType,message,setMessage,tree,isAlertOpen,setIsAlertOpen }: BaseCallBackInterface) {
    const formContext = useForm<{}>({
        defaultValues: {
        }
    });

    //  used for the modal. depreciated
    const [dropDownMethods,setDropDownMethods] = useState<string[]>()
    const [MFAMethod, setMFAMethod] = useState('1');
    
  const [isDisabled,setDisabled] = useState(false);

    useEffect(()=>{
        if(!!step){
            setDropDownMethods(step.callbacks[0].getOutputByName("choices",[""])!);
           
        } 
        /* if(!!dropDownMethods){
            setMFAMethod(dropDownMethods!.at(1)!)
        }  */
       
    },[dropDownMethods, step])


    //  ---------------------METHODS-----------------------------------
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function fillStep(step: FRStep, data: any): void {
        setDisabled(true);
        handleClose();
        const fillStep = step;
        fillStep.callbacks[0].setInputValue(MFAMethod);
        setStep(fillStep);
        setTimeout(()=>{
            setDisabled(false);
          },2)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSuccess = async (data: any) => {
        fillStep(step as FRStep, data);
        let nextStep = await FRAuth.next(step as FRStep,{tree});
       /*  if (nextStep.type === 'LoginFailure') {
            setErrorMessage(nextStep.payload.message || '')
            setError(true);
            handleOpen();
            nextStep = await FRAuth.start({ tree: trees.login });

        } else {
            dispatch(toggleLogin())
            setError(false);
        } */

        setStep(nextStep);
    };

    const handleOpen = () => {
        setIsAlertOpen(true);
    };
    const handleClose = () => {
        setIsAlertOpen(false);
    };

    const handleChange = (event: SelectChangeEvent) => {
        setMFAMethod(event.target.value as string);
      };

    //  -----------------END METHODS-----------------------------------

    return (
        <>
            <FormContainer
                defaultValues={{}}
                formContext={formContext}
                onSuccess={handleSuccess}>
                <SuccessErrorModal
                    open={isAlertOpen}
                    message={message}
                    handleClose={handleClose}
                    type={messageType}
                />
                <FormLayout
                header={step.getHeader()}
                subHeader={step.getDescription()}
                    button={(<button  id="submit_button" className={`accent-1 submit`} disabled={isDisabled} type="submit" >Continue</button>)}>
                    <FormSection>
                        <Row>
                        <FormControl sx={{ m: 1, minWidth: 240 }}>
                            <InputLabel >Select Your MFA Method</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={MFAMethod}
                                label="Select Your MFA Method"
                                onChange={handleChange}
                            >
                                    {!!dropDownMethods && dropDownMethods!.map((item, index) => {
                                        if (index === 1) {
                                            return <MenuItem key={index} selected={true} value={index} >{item}</MenuItem>
                                        } else {
                                            return <MenuItem key={index} value={index}>{item}</MenuItem>
                                        }

                                    })}
                                </Select>
                            </FormControl>
                        </Row>
                    </FormSection>

                </FormLayout>
            </FormContainer>
        </>
    );
}
